<script setup lang="ts">
import { NxtInput } from '@future-harry/nxt-styles';
import { JobBoard } from '@/core/collections/job-boards/job-board.interface';
import { useSettingsStore } from '@/apps/admin/stores/settings.store';

const jobBoard = defineModel<JobBoard>('modelValue', { required: true });
const settingsStore = useSettingsStore();
const jobBoardSettingsErrors = computed(() => settingsStore.validationErrors.value);
</script>

<template>
   <section>
      <div class="row">
         <div class="col-half">
            <NxtInput
               name="social_urls.facebook"
               :label="$t('job-board.settings.social_media.facebook')"
               :label-icon-class="'fab fa-square-facebook'"
               :errors="jobBoardSettingsErrors"
               v-model="jobBoard.social_urls.facebook"
            />
         </div>
      </div>
      <div class="row">
         <div class="col-half">
            <NxtInput
               name="social_urls.x"
               :label="$t('job-board.settings.social_media.x')"
               :label-icon-class="'fab fa-x-twitter'"
               :errors="jobBoardSettingsErrors"
               v-model="jobBoard.social_urls.x"
            />
         </div>
      </div>
      <div class="row">
         <div class="col-half">
            <NxtInput
               name="social_urls.linkedin"
               :label="$t('job-board.settings.social_media.linkedin')"
               :label-icon-class="'fab fa-linkedin'"
               :errors="jobBoardSettingsErrors"
               v-model="jobBoard.social_urls.linkedin"
            />
         </div>
      </div>
      <div class="row">
         <div class="col-half">
            <NxtInput
               name="social_urls.instagram"
               :label="$t('job-board.settings.social_media.instagram')"
               :label-icon-class="'fab fa-instagram'"
               :errors="jobBoardSettingsErrors"
               v-model="jobBoard.social_urls.instagram"
            />
         </div>
      </div>
   </section>
</template>

<style lang="scss" scoped>
/* (nxt-styles) logo is behind label: reverse this order to have logo in front */
:deep(.nxt-form-group .nxt-form-group__label) {
   flex-direction: row-reverse;
   gap: var(--nxt-gutter-small);
   align-items: center;
}
</style>
